module.exports = __webpack_public_path__ + "d2afc54d40ab8d3fbefd7b92d66773f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-21-harrison/diary.jpg
// module id = 897
// module chunks = 0